import React, { useEffect, useState } from "react";
import { CompanyDetailsSections, getActiveSectionIndex } from "@/screen/Companies/CompanyDetails/companyDetailsSections";
import type { CompanyDetailsSection } from "@/screen/Companies/CompanyDetails/companyDetailsSections";
import { SectionNav } from "@/screen/Companies/Styles/CompanyDetailsStyles";

// Línea de lectura: una sección pasa a ser la activa cuando su título llega a esta distancia del borde superior
const ReadingLineOffset = 140;

interface CompanyDetailsSectionNavProps
{
    // Secciones de la pantalla (por defecto, las del paso 3)
    sections?: CompanyDetailsSection[];
}

// Índice lateral de los pasos 3 y 4 (maqueta): enlaza a cada sección y resalta la que se está viendo
const CompanyDetailsSectionNav: React.FC<CompanyDetailsSectionNavProps> = ({ sections = CompanyDetailsSections }) =>
{
    const [activeIndex, setActiveIndex] = useState<number>(0);

    useEffect(() =>
    {
        let frame = 0;
        const update = (): void =>
        {
            cancelAnimationFrame(frame);
            frame = requestAnimationFrame(() =>
            {
                const tops = sections.map((section) => document.getElementById(section.id)?.getBoundingClientRect().top ?? Number.POSITIVE_INFINITY);
                const reachedBottom = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 4;
                setActiveIndex(getActiveSectionIndex(tops, ReadingLineOffset, reachedBottom));
            });
        };

        update();
        window.addEventListener("scroll", update, { passive: true });
        window.addEventListener("resize", update);
        return () =>
        {
            cancelAnimationFrame(frame);
            window.removeEventListener("scroll", update);
            window.removeEventListener("resize", update);
        };
    }, [sections]);

    const goTo = (e: React.MouseEvent<HTMLAnchorElement>, id: string, index: number): void =>
    {
        // Sin cambiar la URL: el router de la app no usa anclas
        e.preventDefault();
        document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
        setActiveIndex(index);
    };

    return(
        <SectionNav aria-label="Secciones">
            <span>SECCIONES</span>
            {sections.map((section, index) =>
            (
                <a key={section.id} href={`#${section.id}`} className={index === activeIndex ? "active" : undefined}
                    aria-current={index === activeIndex ? "true" : undefined} onClick={(e) => goTo(e, section.id, index)}
                >
                    <i>{section.number}</i>
                    {section.title}
                </a>
            ))}
        </SectionNav>
    );
};

export default CompanyDetailsSectionNav;
